import { useSelector } from "react-redux";
import {
  customerChatMainCategories,
  customerChatSubCategories,
  agentChatMainCategories,
  agentChatSubCategories,
} from "js/sfdc";
import { isAgentPortal } from "js/utilities";

import useIsChatOnline from "hooks/useIsChatOnline";

import ChatOfflineWindow from "components/Chat/ChatOfflineWindow";
import FloatingChatButton from "components/Chat/FloatingChatButton";
import ChatAuthedFormWindow from "components/Chat/ChatAuthedFormWindow";

export default function AuthenticatedUserChat({
  hideCustomChat,
  setHideCustomChat,
  connectingToSF,
  setConnectingToSF,
  openChatWindow,
  setOpenChatWindow,
  policies,
}) {
  const chatOnline = useIsChatOnline(openChatWindow);
  const { user } = useSelector((s) => s.user);

  if (hideCustomChat) return <></>;

  if (!openChatWindow)
    return (
      <FloatingChatButton
        chatOnline={chatOnline}
        setOpenChatWindow={setOpenChatWindow}
      />
    );

  if (chatOnline)
    return (
      <ChatAuthedFormWindow
        user={user}
        policies={policies}
        mainCategories={
          isAgentPortal() ? agentChatMainCategories : customerChatMainCategories
        }
        subCategories={
          isAgentPortal() ? agentChatSubCategories : customerChatSubCategories
        }
        setHideCustomChat={setHideCustomChat}
        connectingToSF={connectingToSF}
        setConnectingToSF={setConnectingToSF}
        openChatWindow={openChatWindow}
        setOpenChatWindow={setOpenChatWindow}
      />
    );

  return <ChatOfflineWindow setOpenChatWindow={setOpenChatWindow} />;
}
